// @mui
import PropTypes from 'prop-types';
import { Box, Link, Divider, CardHeader } from '@mui/material';
// utils
import { fToNow } from '../../../utils/formatTime';
// components
import Iconify from '../../../components/Iconify';
import Scrollbar from '../../../components/Scrollbar';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';

import {
    Card,
    Table,
    Stack,
    Avatar,
    Button,
    Checkbox,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    TableContainer,
    TablePagination,
} from '@mui/material';

import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import LoadingScreen from 'react-loading-screen';

import UserService from '../../../services/user_service'

// ----------------------------------------------------------------------

UserApps.propTypes = {
    title: PropTypes.string,
    subheader: PropTypes.string,
    app_id: PropTypes.string
};

export default function UserApps({ title, subheader, app_id, ...other }) {

    const params = useParams();

    const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const theme = useTheme();
    const [data, setData] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();


    function loadApps() {
        UserService.getUsersApps(app_id, page)
            .then((response) => response.data)
            .then((data) => setData(data['data']))
            .then((data) => setIsLoading(false))
            .catch((error) => console.log(error));
    }

    useEffect(() => {
        // if (isLoading) {
        loadApps();
        // }
    }, []);


    const handleViewAll = () => {
        // dispatch({ type: 'USER', payload: { 'user': params.user_id, 'selected': 'APPS' } })
        navigate("/users/" + params.user_id + '/apps');
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        loadApps();
    };

    if (isLoading) {
        return (
            <Card {...other}>
                <CardHeader title={title} subheader={subheader} />
                <LoadingScreen
                    loading={true}
                    bgColor="rgba(255,255,255,0.8)"
                    spinnerColor="#9ee5f8"
                    textColor="#676767"
                    logoSrc=""
                    text=""
                >
                    {" "}
                </LoadingScreen>
            </Card>
        )
    }
    else {
        return (
            <Card {...other}>
                <CardHeader title={title} subheader={subheader} />



                <Scrollbar>
                    <TableContainer >
                        <Table>


                            <TableBody>
                                {data.map((app) => (
                                    <AppItem key={app.id} app={app} />
                                ))
                                }


                            </TableBody>


                        </Table>
                    </TableContainer>

                </Scrollbar>

                <Divider />

                <Box sx={{ p: 2, textAlign: 'right' }}>
                    <Button type="button" onClick={handleViewAll} size="small" color="inherit" endIcon={<Iconify icon={'eva:arrow-ios-forward-fill'} />}>
                        View all
                    </Button>
                </Box>
            </Card>
        );
    }
}

// ----------------------------------------------------------------------

AppItem.propTypes = {
    app: PropTypes.shape({
        username: PropTypes.string,
        user_id: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        source_name: PropTypes.string,
        bot_blocked: PropTypes.string
    }),
};



function AppItem({ app }) {
    const { id, app_id, app_name, avatar, country_code, seller_name, store_type } = app;

    return (
        <TableRow sx={{ cursor: 'pointer' }}>
            <TableCell >
                <Avatar src={avatar} />
            </TableCell>
            <TableCell>
                {/* <Stack direction="row" alignItems="center"> */}
                <Typography variant="subtitle2" noWrap>
                    {app_name}
                </Typography>
                {/* </Stack> */}
                <Link color="inherit" variant="subtitle2" underline="hover" noWrap>
                    {app_id}
                </Link>
                <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                    {seller_name}
                </Typography>
            </TableCell>

            <TableCell>
                <Typography variant="caption" sx={{ pr: 3, flexShrink: 0, color: 'text.secondary' }}>
                    {store_type}
                </Typography>
            </TableCell>
        </TableRow >
    );
}
